import { deepMerge } from '../locales/merge';
import { DRAWER_UI } from './drawerUiTranslations';
import { FINAL_UI, STORY_UI } from './finalScreenUiTranslations';
import { getUserFacingOverlay } from './userFacingOverlayTranslations';
import { getOpsFacingOverlay } from './opsFacingOverlayTranslations';
import { getLeftoverHardcodedOverlay } from './leftoverHardcodedOverlayTranslations';

/** Full-screen UI copy for overlay locales (+ ko extras). Merged into locale dicts. */

const NEWS_AGO_TH = {
  justNow: 'เมื่อสักครู่',
  minutes: '{n} นาทีที่แล้ว',
  hours: '{n} ชม.ที่แล้ว',
  days: '{n} วันที่แล้ว',
};

const HOME_UI = {
  th: {
    sectionVnNews: '📰 ข่าวเวียดนาม',
    ariaVnNews: 'ข่าวเวียดนาม',
    sectionCountryNews: 'ข่าว {country}',
    ariaCountryNews: 'ข่าว {country}',
    sectionMingoStory: '🎬 Mingo Story',
    sectionHotCommunity: '💬 โพสต์ยอดนิยม',
    sectionNearbyBiz: '📍 ธุรกิจใกล้คุณ',
    more: 'ดูเพิ่ม',
    emptySection: 'ยังไม่มีรายการ',
    listingTime: { yesterday: 'เมื่อวาน', bumpMinutes: 'ดึงขึ้น {n} นาทีที่แล้ว' },
    newsAgo: NEWS_AGO_TH,
    newsSource: { embassy: 'สถานทูต', local: 'ท้องถิ่น', exchange: 'อัตราแลกเปลี่ยน', general: 'ข่าว', insidevina: 'InsideVina', default: 'ข่าว' },
    newsCategory: { visa: 'วีซ่า', local: 'ท้องถิ่น', economy: 'เศรษฐกิจ', general: 'ทั่วไป' },
  },
  ja: {
    sectionVnNews: '📰 ベトナムニュース',
    sectionCountryNews: '{country}ニュース',
    ariaCountryNews: '{country}ニュース',
    sectionMingoStory: '🎬 Mingo Story',
    sectionHotCommunity: '💬 人気投稿',
    sectionNearbyBiz: '📍 近くの店舗',
    more: 'もっと見る',
    listingTime: { yesterday: '昨日', bumpMinutes: 'UP {n}分前' },
    newsAgo: { justNow: 'たった今', minutes: '{n}分前', hours: '{n}時間前', days: '{n}日前' },
    newsCategory: { visa: 'ビザ', local: 'ローカル', economy: '経済', general: '一般' },
  },
  'zh-CN': {
    sectionVnNews: '📰 越南新闻',
    sectionCountryNews: '{country}新闻',
    ariaCountryNews: '{country}新闻',
    sectionMingoStory: '🎬 Mingo Story',
    sectionHotCommunity: '💬 热门帖子',
    sectionNearbyBiz: '📍 附近商家',
    more: '更多',
    listingTime: { yesterday: '昨天', bumpMinutes: '顶 {n} 分钟前' },
    newsAgo: { justNow: '刚刚', minutes: '{n}分钟前', hours: '{n}小时前', days: '{n}天前' },
    newsCategory: { visa: '签证', local: '本地', economy: '经济', general: '综合' },
  },
  'zh-TW': {
    sectionVnNews: '📰 越南新聞',
    sectionCountryNews: '{country}新聞',
    ariaCountryNews: '{country}新聞',
    sectionMingoStory: '🎬 Mingo Story',
    sectionHotCommunity: '💬 熱門貼文',
    sectionNearbyBiz: '📍 附近商家',
    more: '更多',
    listingTime: { yesterday: '昨天', bumpMinutes: '頂 {n} 分鐘前' },
    newsAgo: { justNow: '剛剛', minutes: '{n}分鐘前', hours: '{n}小時前', days: '{n}天前' },
    newsCategory: { visa: '簽證', local: '本地', economy: '經濟', general: '綜合' },
  },
  vi: {
    sectionVnNews: '📰 Tin Việt Nam',
    sectionCountryNews: 'Tin tức {country}',
    ariaCountryNews: 'Tin tức {country}',
    sectionMingoStory: '🎬 Mingo Story',
    sectionHotCommunity: '💬 Bài viết phổ biến',
    sectionNearbyBiz: '📍 Doanh nghiệp gần bạn',
    more: 'Xem thêm',
    listingTime: { yesterday: 'Hôm qua', bumpMinutes: 'Đẩy {n} phút trước' },
    newsAgo: { justNow: 'Vừa xong', minutes: '{n} phút trước', hours: '{n} giờ trước', days: '{n} ngày trước' },
    newsCategory: { visa: 'Visa', local: 'Địa phương', economy: 'Kinh tế', general: 'Chung' },
  },
  ru: {
    sectionVnNews: '📰 Новости Вьетнама',
    sectionCountryNews: 'Новости {country}',
    ariaCountryNews: 'Новости {country}',
    sectionMingoStory: '🎬 Mingo Story',
    sectionHotCommunity: '💬 Популярные посты',
    sectionNearbyBiz: '📍 Бизнес рядом',
    more: 'Ещё',
    listingTime: { yesterday: 'Вчера', bumpMinutes: 'Поднято {n} мин назад' },
    newsAgo: { justNow: 'Только что', minutes: '{n} мин назад', hours: '{n} ч назад', days: '{n} дн назад' },
    newsCategory: { visa: 'Виза', local: 'Местное', economy: 'Экономика', general: 'Общее' },
  },
  id: {
    sectionVnNews: '📰 Berita Vietnam',
    sectionCountryNews: 'Berita {country}',
    ariaCountryNews: 'Berita {country}',
    sectionMingoStory: '🎬 Mingo Story',
    sectionHotCommunity: '💬 Posting populer',
    sectionNearbyBiz: '📍 Bisnis terdekat',
    more: 'Lainnya',
    listingTime: { yesterday: 'Kemarin', bumpMinutes: 'Naik {n} mnt lalu' },
    newsAgo: { justNow: 'Baru saja', minutes: '{n} mnt lalu', hours: '{n} jam lalu', days: '{n} hari lalu' },
    newsCategory: { visa: 'Visa', local: 'Lokal', economy: 'Ekonomi', general: 'Umum' },
  },
  hi: {
    sectionVnNews: '📰 वियतनाम समाचार',
    sectionCountryNews: '{country} समाचार',
    ariaCountryNews: '{country} समाचार',
    sectionMingoStory: '🎬 Mingo Story',
    sectionHotCommunity: '💬 लोकप्रिय पोस्ट',
    sectionNearbyBiz: '📍 पास के व्यवसाय',
    more: 'और',
    listingTime: { yesterday: 'कल', bumpMinutes: 'बूस्ट {n} मिनट पहले' },
    newsAgo: { justNow: 'अभी', minutes: '{n} मिनट पहले', hours: '{n} घंटे पहले', days: '{n} दिन पहले' },
    newsCategory: { visa: 'वीज़ा', local: 'स्थानीय', economy: 'अर्थव्यवस्था', general: 'सामान्य' },
  },
  ko: {
    listingTime: { yesterday: '어제', bumpMinutes: '끌올 {n}분 전' },
  },
  en: {
    listingTime: { yesterday: 'Yesterday', bumpMinutes: 'Bumped {n}m ago' },
  },
};

const WRITE_UI = {
  th: { tradeTitle: '+ ลงประกาศใหม่' },
  ja: { tradeTitle: '+ 新規出品' },
  'zh-CN': { tradeTitle: '+ 发布商品' },
  'zh-TW': { tradeTitle: '+ 刊登商品' },
  vi: { tradeTitle: '+ Đăng tin mới' },
  ru: { tradeTitle: '+ Новое объявление' },
  id: { tradeTitle: '+ Pasang iklan' },
  hi: { tradeTitle: '+ नई लिस्टिंग' },
};

const PD = (o) => ({
  back: o[0],
  more: o[1],
  chat: o[2],
  views: o[3],
  favorite: o[4],
  favoriteOn: o[5],
  favoriteCount: o[6],
  similarProducts: o[7],
  commissionTrade: o[8],
  safePaymentSoon: o[9],
  sliderLabel: o[10] || o[0],
});

const SCREEN = {
  ja: {
    productDetail: PD([
      '戻る', 'その他', 'チャット', '閲覧 {count}', '保存', '保存済み', '保存 {count}',
      '類似商品', '安全取引手数料 {rate}% · 約 {fee} {currency}', 'アプリ内決済は近日公開',
      '商品画像',
    ]),
    shorts: {
      discover: '発見', storyHome: 'ストーリーホーム',
      storyTabNearby: '📍 近く', storyTabWebtoon: '🎨 ウェブトーン', storyTabPopular: '⭐ 人気',
      dislike: '低評価', sheetDesc: '説明', sheetNotInterested: '興味なし', sheetReport: '報告',
    },
    shortsV2: { tabDiscover: '発見', tabStoryHome: 'ストーリーホーム', create: '投稿' },
    local: {
      emergencySection: '🆘 緊急・安全', emergency: '緊急連絡先', lostFound: '遺失物', expiry: '期限リマインダー',
      expatInfoTitle: '外国人必須ガイド',
    },
    life: { favoritesSection: 'お気に入り' },
    serviceV2: {
      secTrade: '🛍️ 取引・ショッピング',
      items: { used: '中古マーケット', vehicles: '中古車', groupBuy: '共同購入', currencyExchange: '両替' },
    },
    community: {
      sortNew: '最新', sortHot: '人気', writeFab: '新規投稿',
      categories: { near: 'マイエリア', all: 'すべて', question: 'Q&A', info: 'ヒント', meet: 'ミートアップ', general: '一般', lost: '紛失', free: '自由', emergency: '緊急', education: '教育' },
    },
    chat: {
      title: 'チャット', newChat: '+ 新規チャット', emptyTitle: 'チャットはまだありません',
      emptyDesc: '仲間の外国人と会話を始めましょう', promoTitle: 'こんなサービスは？',
      promoInvite: '友達を招待', promoTheme: '外観', promoThemeDesc: 'チャットテーマをカスタム',
    },
    home: { quickInfoAria: '天気とビザラン', exchangeTitle: '為替', close: '閉じる' },
    btn: { share: '共有', save: '保存', write: '投稿' },
    trade: { laneUsed: '中古', laneRent: 'レンタル', laneJobs: '求人' },
    common: { report: '報告' },
  },
  'zh-CN': {
    productDetail: PD([
      '返回', '更多', '聊天', '浏览 {count}', '收藏', '已收藏', '收藏 {count}',
      '相似商品', '安全交易费 {rate}% · 约 {fee} {currency}', '应用内支付即将推出', '商品图片',
    ]),
    shorts: {
      discover: '发现', storyHome: '故事首页',
      storyTabNearby: '📍 附近', storyTabWebtoon: '🎨 网漫', storyTabPopular: '⭐ 热门',
      dislike: '不喜欢', sheetDesc: '说明', sheetNotInterested: '不感兴趣', sheetReport: '举报',
    },
    shortsV2: { tabDiscover: '发现', tabStoryHome: '故事首页', create: '发布' },
    local: {
      emergencySection: '🆘 紧急与安全', emergency: '紧急联系', lostFound: '失物招领', expiry: '到期提醒',
      expatInfoTitle: '外籍必备指南',
    },
    life: { favoritesSection: '收藏' },
    serviceV2: {
      secTrade: '🛍️ 交易与购物',
      items: { used: '二手市场', vehicles: '二手车', groupBuy: '团购', currencyExchange: '换汇' },
    },
    community: {
      sortNew: '最新', sortHot: '热门', writeFab: '发帖',
      categories: { near: '我的地区', all: '全部', question: '问答', info: '贴士', meet: '聚会', general: '综合', lost: '失物', free: '自由', emergency: '紧急', education: '教育' },
    },
    chat: {
      title: '聊天', newChat: '+ 新聊天', emptyTitle: '还没有聊天',
      emptyDesc: '和外籍朋友开始对话吧', promoTitle: '试试这些服务',
      promoInvite: '邀请好友', promoTheme: '外观', promoThemeDesc: '自定义聊天主题',
    },
    home: { quickInfoAria: '天气与签证跑', exchangeTitle: '汇率', close: '关闭' },
    btn: { share: '分享', save: '保存', write: '发布' },
    trade: { laneUsed: '二手', laneRent: '租赁', laneJobs: '招聘' },
    common: { report: '举报' },
  },
  'zh-TW': {
    productDetail: PD([
      '返回', '更多', '聊天', '瀏覽 {count}', '收藏', '已收藏', '收藏 {count}',
      '相似商品', '安全交易費 {rate}% · 約 {fee} {currency}', '應用內付款即將推出', '商品圖片',
    ]),
    shorts: {
      discover: '發現', storyHome: '故事首頁',
      storyTabNearby: '📍 附近', storyTabWebtoon: '🎨 網漫', storyTabPopular: '⭐ 熱門',
      dislike: '不喜歡', sheetDesc: '說明', sheetNotInterested: '不感興趣', sheetReport: '檢舉',
    },
    shortsV2: { tabDiscover: '發現', tabStoryHome: '故事首頁', create: '發布' },
    local: {
      emergencySection: '🆘 緊急與安全', emergency: '緊急聯絡', lostFound: '失物招領', expiry: '到期提醒',
      expatInfoTitle: '外籍必備指南',
    },
    life: { favoritesSection: '收藏' },
    serviceV2: {
      secTrade: '🛍️ 交易與購物',
      items: { used: '二手市場', vehicles: '二手車', groupBuy: '團購', currencyExchange: '換匯' },
    },
    community: {
      sortNew: '最新', sortHot: '熱門', writeFab: '發文',
      categories: { near: '我的地區', all: '全部', question: '問答', info: '貼士', meet: '聚會', general: '綜合', lost: '失物', free: '自由', emergency: '緊急', education: '教育' },
    },
    chat: {
      title: '聊天', newChat: '+ 新聊天', emptyTitle: '還沒有聊天',
      emptyDesc: '和外籍朋友開始對話吧', promoTitle: '試試這些服務',
      promoInvite: '邀請好友', promoTheme: '外觀', promoThemeDesc: '自訂聊天主題',
    },
    home: { quickInfoAria: '天氣與簽證跑', exchangeTitle: '匯率', close: '關閉' },
    btn: { share: '分享', save: '儲存', write: '發布' },
    trade: { laneUsed: '二手', laneRent: '租賃', laneJobs: '招聘' },
    common: { report: '檢舉' },
  },
  vi: {
    productDetail: PD([
      'Quay lại', 'Thêm', 'Trò chuyện', '{count} lượt xem', 'Lưu', 'Đã lưu', '{count} lượt lưu',
      'Sản phẩm tương tự', 'Phí giao dịch an toàn {rate}% · khoảng {fee} {currency}', 'Thanh toán trong app sắp ra mắt',
      'Ảnh sản phẩm',
    ]),
    shorts: {
      discover: 'Khám phá', storyHome: 'Trang truyện',
      storyTabNearby: '📍 Gần tôi', storyTabWebtoon: '🎨 Webtoon', storyTabPopular: '⭐ Phổ biến',
      dislike: 'Không thích', sheetDesc: 'Mô tả', sheetNotInterested: 'Không quan tâm', sheetReport: 'Báo cáo',
    },
    shortsV2: { tabDiscover: 'Khám phá', tabStoryHome: 'Trang truyện', create: 'Đăng' },
    local: {
      emergencySection: '🆘 Khẩn cấp & An toàn', emergency: 'Liên hệ khẩn cấp', lostFound: 'Đồ thất lạc',
      expiry: 'Nhắc hạn dùng', expatInfoTitle: 'Cẩm nang thiết yếu',
    },
    life: { favoritesSection: 'Yêu thích' },
    serviceV2: {
      secTrade: '🛍️ Mua bán & Mua sắm',
      items: { used: 'Chợ đồ cũ', vehicles: 'Xe cũ', groupBuy: 'Mua chung', currencyExchange: 'Đổi tiền' },
    },
    community: {
      sortNew: 'Mới nhất', sortHot: 'Phổ biến', writeFab: 'Bài mới',
      categories: { near: 'Khu vực của tôi', all: 'Tất cả', qna: 'Hỏi đáp', share: 'Chia sẻ & báo cáo', question: 'Hỏi đáp', info: 'Mẹo', meet: 'Gặp gỡ', general: 'Chung', lost: 'Thất lạc', free: 'Tự do', emergency: 'Khẩn cấp', education: 'Giáo dục' },
    },
    chat: {
      title: 'Trò chuyện', newChat: '+ Chat mới', emptyTitle: 'Chưa có cuộc trò chuyện',
      emptyDesc: 'Bắt đầu trò chuyện với cộng đồng expat', promoTitle: 'Khám phá dịch vụ',
      promoInvite: 'Mời bạn bè', promoTheme: 'Giao diện', promoThemeDesc: 'Tùy chỉnh giao diện chat',
    },
    home: { quickInfoAria: 'Thời tiết & Visa run', exchangeTitle: 'Tỷ giá', close: 'Đóng' },
    btn: { share: 'Chia sẻ', save: 'Lưu', write: 'Đăng' },
    trade: { laneUsed: 'Đồ cũ', laneRent: 'Thuê', laneJobs: 'Việc làm' },
    common: { report: 'Báo cáo' },
  },
  ru: {
    productDetail: PD([
      'Назад', 'Ещё', 'Чат', '{count} просмотров', 'Сохранить', 'Сохранено', '{count} сохранений',
      'Похожие товары', 'Комиссия {rate}% · около {fee} {currency}', 'Оплата в приложении скоро',
      'Фото товара',
    ]),
    shorts: {
      discover: 'Обзор', storyHome: 'Лента',
      storyTabNearby: '📍 Рядом', storyTabWebtoon: '🎨 Вебтун', storyTabPopular: '⭐ Популярное',
      dislike: 'Не нравится', sheetDesc: 'Описание', sheetNotInterested: 'Не интересно', sheetReport: 'Жалоба',
    },
    shortsV2: { tabDiscover: 'Обзор', tabStoryHome: 'Лента', create: 'Создать' },
    local: {
      emergencySection: '🆘 Экстренно и безопасность', emergency: 'Экстренные контакты', lostFound: 'Потерянные вещи',
      expiry: 'Напоминание о сроке', expatInfoTitle: 'Гид для экспатов',
    },
    life: { favoritesSection: 'Избранное' },
    serviceV2: {
      secTrade: '🛍️ Торговля и покупки',
      items: { used: 'Барахолка', vehicles: 'Авто', groupBuy: 'Совместная покупка', currencyExchange: 'Обмен валют' },
    },
    community: {
      sortNew: 'Новые', sortHot: 'Популярные', writeFab: 'Новый пост',
      categories: { near: 'Мой район', all: 'Все', qna: 'Вопросы', share: 'Истории и отчёты', question: 'Вопросы', info: 'Советы', meet: 'Встречи', general: 'Общее', lost: 'Потеряно', free: 'Свободно', emergency: 'Срочно', education: 'Образование' },
    },
    chat: {
      title: 'Чаты', newChat: '+ Новый чат', emptyTitle: 'Чатов пока нет',
      emptyDesc: 'Начните общение с экспатами', promoTitle: 'Попробуйте сервисы',
      promoInvite: 'Пригласить друзей', promoTheme: 'Оформление', promoThemeDesc: 'Тема чата',
    },
    home: { quickInfoAria: 'Погода и виза-ран', exchangeTitle: 'Курс', close: 'Закрыть' },
    btn: { share: 'Поделиться', save: 'Сохранить', write: 'Написать' },
    trade: { laneUsed: 'Б/у', laneRent: 'Аренда', laneJobs: 'Работа' },
    common: { report: 'Жалоба' },
  },
  th: {
    productDetail: PD([
      'กลับ', 'เพิ่มเติม', 'แชท', 'ดู {count} ครั้ง', 'บันทึก', 'บันทึกแล้ว', 'บันทึก {count}',
      'สินค้าที่คล้ายกัน', 'ค่าธรรมเนียม {rate}% · ประมาณ {fee} {currency}', 'ชำระเงินในแอปเร็วๆ นี้',
      'รูปสินค้า',
    ]),
    shorts: {
      discover: 'ค้นพบ', storyHome: 'หน้า Story',
      storyTabNearby: '📍 ใกล้ฉัน', storyTabWebtoon: '🎨 เว็บตูน', storyTabPopular: '⭐ ยอดนิยม',
      dislike: 'ไม่ชอบ', sheetDesc: 'คำอธิบาย', sheetNotInterested: 'ไม่สนใจ', sheetReport: 'รายงาน',
    },
    shortsV2: { tabDiscover: 'ค้นพบ', tabStoryHome: 'หน้า Story', create: 'โพสต์' },
    local: {
      emergencySection: '🆘 ฉุกเฉินและความปลอดภัย', emergency: 'ติดต่อฉุกเฉิน', lostFound: 'ของหาย',
      expiry: 'แจ้งเตือนหมดอายุ', expatInfoTitle: 'คู่มือชาวต่างชาติ',
    },
    life: { favoritesSection: 'รายการโปรด' },
    serviceV2: {
      secTrade: '🛍️ ซื้อขายและช้อปปิ้ง',
      items: { used: 'ตลาดมือสอง', vehicles: 'รถมือสอง', groupBuy: 'ซื้อร่วม', currencyExchange: 'แลกเงิน' },
    },
    community: {
      sortNew: 'ล่าสุด', sortHot: 'ยอดนิยม', writeFab: 'โพสต์ใหม่',
      categories: { near: 'พื้นที่ของฉัน', all: 'ทั้งหมด', question: 'ถาม-ตอบ', info: 'เคล็ดลับ', meet: 'นัดพบ', general: 'ทั่วไป', lost: 'ของหาย', free: 'อิสระ', emergency: 'ฉุกเฉิน', education: 'การศึกษา' },
    },
    chat: {
      title: 'แชท', newChat: '+ แชทใหม่', emptyTitle: 'ยังไม่มีแชท',
      emptyDesc: 'เริ่มคุยกับชาวต่างชาติ', promoTitle: 'ลองบริการเหล่านี้',
      promoInvite: 'ชวนเพื่อน', promoTheme: 'ธีม', promoThemeDesc: 'ปรับธีมแชท',
    },
    home: { quickInfoAria: 'อากาศและวิซ่ารัน', exchangeTitle: 'อัตราแลกเปลี่ยน', close: 'ปิด' },
    btn: { share: 'แชร์', save: 'บันทึก', write: 'เขียน' },
    trade: { laneUsed: 'มือสอง', laneRent: 'เช่า', laneJobs: 'งาน' },
    common: { report: 'รายงาน' },
  },
  id: {
    productDetail: PD([
      'Kembali', 'Lainnya', 'Obrolan', '{count} tayangan', 'Simpan', 'Tersimpan', '{count} simpanan',
      'Barang serupa', 'Biaya aman {rate}% · sekitar {fee} {currency}', 'Pembayaran in-app segera',
      'Foto produk',
    ]),
    shorts: {
      discover: 'Jelajahi', storyHome: 'Beranda Story',
      storyTabNearby: '📍 Dekat saya', storyTabWebtoon: '🎨 Webtoon', storyTabPopular: '⭐ Populer',
      dislike: 'Tidak suka', sheetDesc: 'Deskripsi', sheetNotInterested: 'Tidak tertarik', sheetReport: 'Laporkan',
    },
    shortsV2: { tabDiscover: 'Jelajahi', tabStoryHome: 'Beranda Story', create: 'Posting' },
    local: {
      emergencySection: '🆘 Darurat & Keamanan', emergency: 'Kontak darurat', lostFound: 'Barang hilang',
      expiry: 'Pengingat kedaluwarsa', expatInfoTitle: 'Panduan ekspat',
    },
    life: { favoritesSection: 'Favorit' },
    serviceV2: {
      secTrade: '🛍️ Jual-beli & Belanja',
      items: { used: 'Pasar bekas', vehicles: 'Kendaraan bekas', groupBuy: 'Beli bersama', currencyExchange: 'Kurs' },
    },
    community: {
      sortNew: 'Terbaru', sortHot: 'Populer', writeFab: 'Posting baru',
      categories: { near: 'Wilayah saya', all: 'Semua', question: 'Tanya jawab', info: 'Tips', meet: 'Bertemu', general: 'Umum', lost: 'Hilang', free: 'Bebas', emergency: 'Darurat', education: 'Pendidikan' },
    },
    chat: {
      title: 'Obrolan', newChat: '+ Obrolan baru', emptyTitle: 'Belum ada obrolan',
      emptyDesc: 'Mulai percakapan dengan sesama ekspat', promoTitle: 'Jelajahi layanan',
      promoInvite: 'Undang teman', promoTheme: 'Tampilan', promoThemeDesc: 'Sesuaikan tema obrolan',
    },
    home: { quickInfoAria: 'Cuaca & Visa run', exchangeTitle: 'Kurs', close: 'Tutup' },
    btn: { share: 'Bagikan', save: 'Simpan', write: 'Tulis' },
    trade: { laneUsed: 'Bekas', laneRent: 'Sewa', laneJobs: 'Lowongan' },
    common: { report: 'Laporkan' },
  },
  hi: {
    productDetail: PD([
      'वापस', 'और', 'चैट', '{count} व्यू', 'सेव', 'सेव्ड', '{count} सेव',
      'मिलते-जुलते आइटम', 'सुरक्षित शुल्क {rate}% · लगभग {fee} {currency}', 'इन-ऐप भुगतान जल्द',
      'उत्पाद फ़ोटो',
    ]),
    shorts: {
      discover: 'खोजें', storyHome: 'स्टोरी होम',
      storyTabNearby: '📍 पास में', storyTabWebtoon: '🎨 वेबटून', storyTabPopular: '⭐ लोकप्रिय',
      dislike: 'नापसंद', sheetDesc: 'विवरण', sheetNotInterested: 'रुचि नहीं', sheetReport: 'रिपोर्ट',
    },
    shortsV2: { tabDiscover: 'खोजें', tabStoryHome: 'स्टोरी होम', create: 'लिखें' },
    local: {
      emergencySection: '🆘 आपातकाल और सुरक्षा', emergency: 'आपात संपर्क', lostFound: 'खोया-पाया',
      expiry: 'समाप्ति अनुस्मारक', expatInfoTitle: 'एक्सपैट गाइड',
    },
    life: { favoritesSection: 'पसंदीदा' },
    serviceV2: {
      secTrade: '🛍️ व्यापार और खरीदारी',
      items: { used: 'पुराना बाज़ार', vehicles: 'पुरानी गाड़ी', groupBuy: 'सामूहिक खरीद', currencyExchange: 'विनिमय' },
    },
    community: {
      sortNew: 'नवीनतम', sortHot: 'लोकप्रिय', writeFab: 'नई पोस्ट',
      categories: { near: 'मेरा क्षेत्र', all: 'सभी', question: 'प्रश्न', info: 'टिप्स', meet: 'मिलन', general: 'सामान्य', lost: 'खोया', free: 'मुक्त', emergency: 'आपात', education: 'शिक्षा' },
    },
    chat: {
      title: 'चैट', newChat: '+ नई चैट', emptyTitle: 'अभी कोई चैट नहीं',
      emptyDesc: 'साथी एक्सपैट से बात शुरू करें', promoTitle: 'ये सेवाएँ देखें',
      promoInvite: 'मित्र आमंत्रित करें', promoTheme: 'दिखावट', promoThemeDesc: 'चैट थीम बदलें',
    },
    home: { quickInfoAria: 'मौसम और वीज़ा रन', exchangeTitle: 'विनिमय दर', close: 'बंद करें' },
    btn: { share: 'साझा', save: 'सेव', write: 'लिखें' },
    trade: { laneUsed: 'पुराना', laneRent: 'किराया', laneJobs: 'नौकरियाँ' },
    common: { report: 'रिपोर्ट' },
  },
  ko: {
    shorts: {
      dislike: '싫어요', sheetDesc: '설명', sheetNotInterested: '관심 없음', sheetReport: '신고',
    },
    home: { quickInfoAria: '날씨와 비자런', exchangeTitle: '환율', close: '닫기' },
  },
  en: {
    shorts: {
      dislike: 'Dislike', sheetDesc: 'Description', sheetNotInterested: 'Not interested', sheetReport: 'Report',
    },
    home: { quickInfoAria: 'Weather and visa run', exchangeTitle: 'Exchange rates', close: 'Close' },
  },
};

export function getScreenUiOverlay(lang) {
  const base = SCREEN[lang] || {};
  const patch = {};
  if (HOME_UI[lang]) patch.home = HOME_UI[lang];
  if (WRITE_UI[lang]) patch.write = WRITE_UI[lang];
  if (STORY_UI[lang]) patch.story = STORY_UI[lang];
  const userFacing = getUserFacingOverlay(lang);
  const opsFacing = getOpsFacingOverlay(lang);
  const leftover = getLeftoverHardcodedOverlay(lang);
  if (DRAWER_UI[lang]) {
    return deepMerge(base, patch, FINAL_UI[lang] || {}, DRAWER_UI[lang], userFacing, opsFacing, leftover);
  }
  if (FINAL_UI[lang]) {
    return deepMerge(base, patch, FINAL_UI[lang], userFacing, opsFacing, leftover);
  }
  return deepMerge(base, patch, userFacing, opsFacing, leftover);
}

export default getScreenUiOverlay;
